import * as React from 'react';
import Svg, { SvgProps, G, Circle, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={25} height={25} {...props}>
      <G transform="translate(1 -1)" fill="none" fillRule="evenodd">
        <Circle stroke="#555559" strokeWidth={2} cx={11.5} cy={13.5} r={11.5} />
        <Path
          d="M11.54 6.44c1.28 0 2.32.34 3.08 1.06.74.68 1.12 1.62 1.12 2.82 0 .9-.26 1.68-.74 2.34-.2.24-.76.76-1.64 1.54-.42.36-.72.72-.92 1.08-.26.44-.38.94-.38 1.48v.46h-1.62v-.46c0-.66.12-1.24.38-1.74.26-.6.94-1.36 2.02-2.32.32-.32.54-.56.68-.72.38-.5.58-1.02.58-1.58 0-.8-.22-1.42-.66-1.86-.48-.48-1.14-.7-1.98-.7-.98 0-1.72.32-2.22.98-.42.56-.64 1.32-.64 2.3H7c0-1.4.4-2.52 1.18-3.36.82-.88 1.94-1.32 3.36-1.32zm-.28 12.18c.34 0 .62.1.86.34.22.22.34.5.34.84 0 .36-.12.64-.34.86-.24.22-.54.34-.86.34-.36 0-.64-.12-.86-.34-.24-.24-.36-.52-.36-.86 0-.34.12-.62.36-.84.22-.24.5-.34.86-.34z"
          fill="#555559"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
}

const QuestionIcon = React.memo(SvgComponent);
export default QuestionIcon;
